import { PatientFilterPanelFormBean } from './filters/PatientFilterPanel.types';

export const PATIENT_FILTER_PANEL_DEFAULT_VALUES: PatientFilterPanelFormBean = {
   patientGroups: [],
};
